import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'COURIER_USER_DETAIL',
        create: 'COURIER_USER_CREATE',
        update: 'COURIER_USER_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        default: utils.cookies.get('market_id'),
        label: this.$t('market_id'),
        show: false,
        col: {
          span: 16
        },
        // render: () => <d2-dict-select name="form_market_id" vModel={ this.form.model.market_id } custom />
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.market_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'company_name',
        default: '',
        label: this.$t('company_name'),
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.company_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "company_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'nick_name',
        default: '',
        label: this.$t('nick_name'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.nick_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "nick_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'user_mobile',
        default: '',
        label: this.$t('user_mobile'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_mobile,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'user_email',
        default: '',
        label: this.$t('user_email'),
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_email,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_email", $$v);
              }
            }
          });
        }
      }, {
        prop: 'user_pwd',
        default: '',
        label: this.$t('user_pwd'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_pwd,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_pwd", $$v);
              }
            }
          });
        }
      }, {
        prop: 'user_status',
        default: '',
        label: this.$t('user_status'),
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "user_status",
              "button": true
            },
            "model": {
              value: _this.form.model.user_status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_status", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {
    /**
         * @description 加载需要的字典数据
         */
    loadDict: function loadDict() {
      // 衣物类型
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  }
};